<div
  class="progress-bar"
  [class]="'progress-bar--' + variant()"
  [attr.role]="ariaLabel() ? 'img' : null"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-hidden]="ariaLabel() ? null : 'true'"
>
  @for (segment of segments(); track segment.kind) {
    <div class="progress-bar__seg" [class]="'progress-bar__seg--' + segment.kind" [style.width.%]="segment.width"></div>
  }
</div>
